import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgendaComponent } from './agenda.component';
import { BodisplayModule } from '../bodisplay';
import { ZoomModule } from '../zoom';
import { PipeModule } from '../pipes';
import { AgendaQueovalService } from './agenda.queoval.services';
import { AfficheComponent } from './affiche/affiche.component';
import { AfficheMonthComponent } from './affiche/month/affiche.month.component';
import { AfficheWeekComponent } from './affiche/week/affiche.week.component';
import { AffichePlanningComponent, PlanningMinWidth, PlanningZIndex } from './affiche/planning/affiche.planning.component';
import { AvatarSearchModule } from '../avatar-search';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    BodisplayModule,
    ZoomModule,
    PipeModule,
    AvatarSearchModule
    //////SelectModule,
  ],
  declarations: [
    AgendaComponent,
    AfficheComponent,
    AfficheMonthComponent,
    AfficheWeekComponent,
    AffichePlanningComponent,
    PlanningMinWidth,
    PlanningZIndex,
    //////SelectComponent
  ],
  exports: [
    AgendaComponent,
    AfficheComponent
    //////SelectComponent
  ],
  providers: [
    AgendaQueovalService
  ]
})
export class AgendaModule { }
